import certificate from '../assets/publications/ijert_certificate.png';
import certificate1 from '../assets/publications/ijert_certificate1.png';

export const achievementData = {
    publications: [
        {
            id: 1,
            journal: 'International Journal of Engineering Research and Technology',
            title: 'A Comprehensive Study on Business Analytics',
            details: 'Examined modern Business Analytics practices, tools, and methodologies, with analysis of their effect on data-driven organizational decision-making.',
            date: 'September 2020',
            field: 'Business Analytics',
            url: 'https://www.ijert.org/a-comprehensive-study-on-business-analytics',
            videoUrl: 'https://www.youtube.com/watch?v=zcfEZRuyj14',
            image: certificate
        },
        {
            id: 2,
            journal: 'International Journal of Engineering Research and Technology',
            title: 'Consequences and Determinants Towards Business Analytics Success',
            details: 'Identified the critical organizational and technical factors that determine analytics implementation success, and the obstacles companies encounter in the process.',
            date: 'September 2020',
            field: 'Business Analytics',
            url: 'https://www.ijert.org/consequences-and-determinants-towards-business-analytics-success',
            videoUrl: 'https://www.youtube.com/watch?v=oAw70pUEk-w',
            image: certificate1
        }
    ]
}